import React from 'react';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMOwnerHelper from 'components/helpers/SMOwnerHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOwnerListSummaryView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  componentDidMount() {
  }
  
  render() {
    
    const owner = this.props.owner;
    let authRows = [];
    
    if (owner.is_verified_facebook) {
      authRows.push(<li key="facebook"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000098")}</li>);
    }
    if (owner.is_verified_email) {
      authRows.push(<li key="email"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000095")}</li>);
    }
    if (owner.is_verified_tel) {
      authRows.push(<li key="tel"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000096")}</li>);
    }
    const createdAt = moment(owner.created_at).format("YYYY/MM/DD");
        
    let goldSuperHost = null;
    let goldSuperHostDescription = null;
    if (owner.rank && owner.rank == SMConst.OwnerRank.SuperHost) {
      goldSuperHost = <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" className="side-host__superhost" />;
      goldSuperHostDescription = 
        <div className="mod-host__superhost-area">          
          <div className="mod-host__superhost-area side-host__superhost-area">
            <div className="mod-host__superhost-text">
              <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" />トップホスト<i className="fa fa-question-circle"></i>
              <span className="mod-tooltip side-host__superhost__help-tooltip">
                <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail side-host__superhost__help-baloon">
                  <span className="baloon-inner">トップホストとは、スペースマーケットの設定する条件をクリアした優良ホストに対して送られる称号です。
                    <span className="mod-host__superhost-notes">
                      <a href={SMAppHelper.helpUrl(SMConst.CommonHelpPageID.AboutTopHost)} className="a__underline">もっと詳しく</a>
                    </span>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>;
    }

    const evaluateConfirmRate = SMOwnerHelper.ownerEvaluationImage(owner.confirm_rate_evaluation);
    const evaluateReplyRate = SMOwnerHelper.ownerEvaluationImage(owner.reply_rate_evaluation);
    const evaluateReplyTimeAvg = SMOwnerHelper.ownerEvaluationImage(owner.reply_time_avg_evaluation);
    
    return(
      <div className="col-sm-12 col-md-4">
        <div className="ta-c mod-host__icon-inner">
          <img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} className="side-user__icon" />
          {goldSuperHost}
        </div>
        <p className="side-host__date">{I18n.t("service.label_000005")}<span className="side-host__date-days">{createdAt}</span></p>
        <h1 className="side-host__name">{SMFormatHelper.ownerName(owner)}</h1>
        {goldSuperHostDescription}
        <div className="side__host-evaluate row">
          <div className="col-xs-4">
            <p className="mod-evaluate__title">{I18n.t("service.label_000058")}
              <span className="mod-evaluate__help">
                <i className="fa fa-question-circle mod-evaluate__question"></i>
                <span className="mod-tooltip mod-evaluate__help-tooltip">
                  <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                    <span className="baloon-inner">予約リクエストが承認された実績等を元に、スペースマーケットが算出した表記です。</span>
                  </span>
                </span>
              </span>
            </p>
            <div className="mod-evaluate__value">
              <img src={evaluateConfirmRate} alt="" className="mod-evaluate__value-img" />
              <span className="mod-evaluate__value-text">{owner.confirm_rate_text}</span>
            </div>
          </div>
          <div className="col-xs-4">
            <p className="mod-evaluate__title">{I18n.t("service.label_000006")}</p>
            <div className="mod-evaluate__value">
              <img src={evaluateReplyRate} alt="" className="mod-evaluate__value-img" />
              <span className="mod-evaluate__value-text">{owner.reply_rate_text}</span>
            </div>
          </div>
          <div className="col-xs-4">
            <p className="mod-evaluate__title">{I18n.t("service.label_000007")}</p>
            <div className="mod-evaluate__value">
              <img src={evaluateReplyTimeAvg} alt="" className="mod-evaluate__value-img" />
              <span className="mod-evaluate__value-text">{owner.reply_time_avg_text}</span>
            </div>
          </div>
        </div>
        <div className="side-user__text">
          <p>{owner.profile}</p>
        </div>
        <div className="side-user__authentication clearfix">
          <div className="side-user__authentication-box">
            <img className="space-main__authentication-icon" src={SMRailsBridge.assetPath.certificationMark} alt={I18n.t("service.label_000010")} />
            <h2 className="side-user__authentication-headline">スペースマーケットによって<br />認証されたホストです。</h2>
          </div>
          <div className="side-user__authentication-check">
            <ul className="user-authentication__check-list">
              {authRows}
            </ul>
          </div>
        </div>
      </div>
    );
  }
  
}
export default SMOwnerListSummaryView;



// WEBPACK FOOTER //
// ./app/javascript/components/owners/SMOwnerListSummaryView.jsx